// Angular
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
// RxJS
import { Observable,of, throwError } from 'rxjs';
import { tap, take, catchError, finalize } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// State
import { AppState } from '../../../../core/reducers';
import { Logout } from '../../../../core/auth/_actions/auth.actions';
import { environment } from '../../../../../environments/environment';
import { Router,NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { isLoggedIn } from '../../../../core/auth/_selectors/_auth.selectors';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { MatSnackBar } from '@angular/material';
/**
 * More information there => https://medium.com/@MetonymyQT/angular-http-interceptors-what-are-they-and-how-to-use-them-52e060321088
 */
@Injectable()
export class InterceptService implements HttpInterceptor {
    returnUrl = null;
	constructor(private router:Router,private translate: TranslateService,private snackBar: MatSnackBar,
		private store:Store<AppState>,private spinnerVisibilityService:SpinnerVisibilityService){
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.returnUrl = event.url;
			}
		});
	}
	// intercept request and add token
	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		// tslint:disable-next-line:no-debugger
		// modify request
		this.spinnerVisibilityService.show();
		request = request.clone({
			setHeaders: {
				Authorization: `Bearer ${localStorage.getItem(environment.authTokenKey)}`,
				'Accept-Language': this.translate.currentLang ? this.translate.currentLang : localStorage.getItem('language')
			}
		});
		// console.log('----request----');
		// console.log(request);
		// console.log('--- end of request---');

		return next.handle(request).pipe(
			tap(
				event => {
					 if (event instanceof HttpResponse) {
						// console.log('all looks good');
						// http response status code
						// console.log(event.status);
						this.spinnerVisibilityService.hide();
						this.snackBar.dismiss();
					}
				},
				error => {
					if(error instanceof HttpErrorResponse) {
						this.spinnerVisibilityService.hide();
						try {
							this.store.pipe(
								select(isLoggedIn),
								tap(isLoggedIn => {
									if (isLoggedIn) {
										if(error.error.code == 401){
											this.store.dispatch(new Logout());
										 }
									}
								})
							).pipe(take(1)).subscribe();
						} catch(e) {
						}
					}
					return of(error);
					// http response status code
					// console.log('----response----');
					// console.error('status code:');
					// tslint:disable-next-line:no-debugger
					//console.error(error.status);
					//console.error(error.message);
					// console.log('--- end of response---');
				}
			),finalize(() => {
				this.spinnerVisibilityService.hide();	
			})
			
		);
	}
}
